makeErrorEnum = require 'app/scripts/lib/make-error-enum'
assert = require 'app/scripts/lib/assert'
xtend = require 'xtend'

HttpError = makeErrorEnum 'Http', [
  'NoResponse'
  'BadRequest'
  'Unauthorized'
  'Forbidden'
  'NotFound'
  'Timeout'
  'Conflict'
  'Precondition'
  'Server'
  'Other'
]

HttpError.fromResponse = (statusCode, text) ->
  assert text || statusCode == 0, "Received a response without any content!"

  if 500 <= statusCode < 600
    HttpError.Server(text)

  switch statusCode
    when 0
      HttpError.NoResponse()
    when 400
      HttpError.BadRequest(text)
    when 401
      HttpError.Unauthorized(text)
    when 403
      HttpError.Forbidden(text)
    when 404
      HttpError.NotFound(text)
    when 408
      HttpError.Timeout(text)
    when 409
      HttpError.Conflict(text)
    when 412
      HttpError.Precondition(text)
    else
      HttpError.Other("#{ statusCode }: #{ text }")

module.exports = HttpError
